import { PlayerProfileInterface } from '@splixer/common';
import { AnyHash, Uuid } from '@hidat/huijs-common';
import { Expose, Transform } from 'class-transformer';
import { dayjsTransformer } from '@hidat/huijs-dates';
import * as dayjs from 'dayjs';

/**
 * Fusion between Listener and Listener Profile
 */
export class PlayerProfile implements PlayerProfileInterface {
  @Expose({ name: 'id' })
  id: Uuid | undefined;

  @Expose({ name: 'listenerId' })
  listenerId: Uuid | undefined;

  @Expose({ name: 'settings' })
  settings: AnyHash | undefined;

  @Expose({ name: 'name' })
  name: string | undefined;

  @Expose({ name: 'email' })
  email: string | undefined;

  @Expose({ name: 'imageUrl' })
  imageUrl: string | undefined;

  @Expose({ name: 'createdAt' })
  @Transform(dayjsTransformer, { toClassOnly: true })
  createdAt: dayjs.Dayjs | undefined;
}
